import { render, staticRenderFns } from "./CarNumber.vue?vue&type=template&id=450f3b56&scoped=true&name=CarNumber&"
import script from "./CarNumber.vue?vue&type=script&lang=js&"
export * from "./CarNumber.vue?vue&type=script&lang=js&"
import style0 from "./CarNumber.vue?vue&type=style&index=0&id=450f3b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f3b56",
  null
  
)

export default component.exports